import { EnvironmentProviders, Provider } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './payment.routes';

export const paymentProviders: Array<Provider | EnvironmentProviders> = [
  provideRouter(routes),
];
